














































import Vue from "vue";
import { SearchAPIModels } from "search-api-client";
import { formatISODateMMDDYYYY } from "@/common/date";
export default Vue.extend({
  name: "Result",
  props: {
    result: {
      type: Object as () => SearchAPIModels.SearchResponseDocument,
      required: true,
      default: [],
    },
    dateformatstring: {
      type: String,
      default: "",
    }
  },
  methods: {
    formatISODate(input: string) {
      const lang = this.$t("Language");
      return formatISODateMMDDYYYY(input, this.dateformatstring, lang);
    },
    getClass(values: SearchAPIModels.KeyValuePair[]) {
      if (values != null && values.length > 0) {
        const gradientProp = values.filter(function(
          value: SearchAPIModels.KeyValuePair
        ) {
          return value.key === "Gradient";
        });
        return gradientProp !== null &&
          gradientProp !== undefined &&
          gradientProp.length > 0
          ? gradientProp[0].value
          : "";
      } else {
        "";
      }
    },
  },
});
